export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    title: that.$l('table_label_rowNum') || 'Excel行号',
    field: 'rowNum',
    width: 100,
    align: 'center',
    showHeaderOverflow: true,
    formatter: ({ cellValue }) => (cellValue || 0) + 1,
  },
  {
    title: that.$l('table_label_errorMsg') || '错误信息',
    field: 'errorMsg',
    minWidth: 200,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
  },
]
